import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CaseInformation.module.scss'
import { confirmCaseNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const ConfirmCaseNumber = ({ t, confirmCaseNumberValid, validateConfirmCaseNumber, confirmCaseNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const confirmCaseNumber = useSelector((state) => state.app.confirmCaseNumber)

  const handleConfirmCaseNumber = (e) => {
    try {
      let number = e.currentTarget.value.replace(/\s/g, '')
      dispatch(confirmCaseNumberAction(number))
      validateConfirmCaseNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validateConfirmCaseNumber(confirmCaseNumber)
  }

  const handleOnPaste = (e) => {
    e.preventDefault()
    return false
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            confirmCaseNumberValid === true
              ? confirmCaseNumber === ''
                ? ''
                : 'form-group has-success'
              : confirmCaseNumberValid === false
                ? 'form-group has-error'
                : ''
          }
        >
          <label className="control-label" htmlFor="ConfirmCaseNumber">
            {t('case_information.confirm_case_number')}
          </label>
          <input
            type="text"
            className={['form-control', styles['field_width']].join(' ')}
            id="ConfirmCaseNumber"
            onBlur={handleOnBlur}
            value={confirmCaseNumber}
            autoComplete="off"
            onChange={handleConfirmCaseNumber}
            onFocus={() => SetIsFocussed(true)}
            onPaste={handleOnPaste}
            maxLength="10"
          />
          {confirmCaseNumberValid === true ? (
            confirmCaseNumber === '' ? (
              ''
            ) : (
                <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              )
          ) : confirmCaseNumberValid === false ? (
            <React.Fragment>
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(confirmCaseNumberError)}</div>
            </React.Fragment>
          ) : (
                ''
              )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(ConfirmCaseNumber)
